import React from "react";

const SelectField = ({
  id,
  label,
  options,
  value,
  onChange,
  disabled = false,
  invalid = false,
  errorMessage = "This field is required.",
  labelPosition = "left", // "top" | "left"
  required = false,
}) => {
  const isTop = labelPosition === "top";

  const selectedLabel =
    options.find((opt) => opt.value === value)?.label || "-";

  return (
    <div
      className={`w-full mb-4 ${
        isTop ? "flex flex-col gap-1" : "flex items-center gap-4"
      }`}
    >
      <label
        htmlFor={id}
        className={`text-base font-medium text-black ${
          isTop ? "" : "whitespace-nowrap"
        }`}
      >
        {label}{required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <div className={isTop ? "w-full" : "flex-1"}>
        {disabled ? (
          /* READ-ONLY DISPLAY */
          <div
            className="px-0 py-1 text-black font-small border-b-2 border-b-gray-300 bg-slate-50"
          >
            {selectedLabel}
          </div>
        ) : (
          /* EDITABLE SELECT */
          <>
            <select
              id={id}
              name={id}
              value={value}
              onChange={onChange}
              className={`text-black appearance-none w-full px-0 py-1 border-0 border-b-2
                ${invalid ? "border-b-red-500" : "border-b-gray-300"}
                focus:outline-none focus:ring-0 focus:border-b-indigo-500
                bg-slate-50 font-small`}
            >
              <option value="" disabled>
                Select
              </option>
              {options.map(({ value, label }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>

            {invalid && !value && (
              <p className="text-sm text-red-500 mt-1">{errorMessage}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SelectField;
